import React from "react";
import TableContainer from "../Common/TableContainer";
import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";

export const CardListSimple = (props) => {
  return (
    <Col xl={12}>
      <div className="live-preview">
        <div className="table-responsive">
          <Table className="table-borderless align-middle table-nowrap mb-0">
            <thead>
              <tr>
                {props.columns.map((column, index) => (
                  <th key={index}>{column.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {props.data.map((item, index) => (
                <tr key={index}>
                  {props.columns.map((column, index) => (
                    <td key={index}>{item[column.accessor]}</td>
                  ))}
                  <td>
                    <div className="hstack gap-3 fs-15 text-end d-flex justify-content-end">
                      <div
                        className="link-success"
                        onClick={() =>
                          props.handleDelete(item[props.accessorDelete])
                        }
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </Col>
  );
};
